import React from "react";
import { sparklinePoints } from "../selectors";

/**
 * Inline trend line for one client's window. Deliberately axis-free — it
 * answers "which way is this going" at a glance; the expanded row carries the
 * numbers.
 */
export function Sparkline({
  values,
  width = 96,
  height = 26,
  tone = "accent",
  title,
}) {
  const points = sparklinePoints(values, { width, height });
  const hasSignal = (values || []).some((value) => Number(value) > 0);

  if (!points) {
    return <span className="ct-spark-empty">—</span>;
  }

  return (
    <svg
      className={`ct-spark ct-spark--${hasSignal ? tone : "muted"}`}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      role="img"
      aria-label={title || "Activity trend"}
    >
      {title ? <title>{title}</title> : null}
      <polyline
        points={points}
        fill="none"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
